export type Region = "au" | "eu" | "us";

export const isValidRegion = (value: any): value is Region => {
  const validRegions = ["au", "eu", "us"];
  return validRegions.includes(value);
};
